import { Reveal } from "@/components/motion/Reveal";
import Seo from "@/components/seo/Seo";

export default function LegalPage({ titulo, cuerpo }) {
  const pathByTitle = {
    "Política de privacidad": "/politica-privacidad",
    "Política de cookies": "/politica-cookies",
    "Términos y condiciones": "/terminos",
  };
  return (
    <main className="pt-[120px] pb-24" data-testid="legal-page">
      <Seo title={titulo} description={`${titulo} del sitio web de KB Consultoría.`} path={pathByTitle[titulo]} />
      <div className="mx-auto max-w-[900px] px-5 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6">— Legal</div>
          <h1 className="display-1">{titulo}</h1>
          <div className="mt-10 prose prose-neutral max-w-none font-sans text-[#1A1A1A] leading-relaxed space-y-6">
            {cuerpo}
          </div>
        </Reveal>
      </div>
    </main>
  );
}
